import React from "react";
import { NoDataAvailableDiv } from "../../components/NoDataAvailableDiv";
import ReadonlyFileList from "../components/File/ReadonlyFileList";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import PanelSegment from "components/panels/PanelSegment/PanelSegment";

interface Props {
  label: string
  files: server.dto.ESignFile[]
  startUncollapsed?: boolean
}

const ReadonlyFilesPanelSegment = (props: Props) => {
  return <SectionPanel.Panel
    header={<>
      <PanelSegment.Title title={props.label} />
    </>}
    collapsible={{
      persist: false,
      start: props.startUncollapsed ? "open" : "closed",
      uniqueRowId: "esignReadonlyFilesPanelSegment"
    }}
  >
    <div>
      {props.files.length > 0 && <ReadonlyFileList
        files={props.files}
      />}
      {props.files.length === 0 && <NoDataAvailableDiv />}
    </div>
  </SectionPanel.Panel>;
};

export default ReadonlyFilesPanelSegment;